// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"a98c1711","633":"1c13edcf","816":"446a94ce"}[chunkId] + ".chunk.js";
};